import TwoStepVerification from './TwoStepVerification';

export default TwoStepVerification;
